export default function wsrvLoader({ src, width, quality }) {
  if (src.startsWith("/_next")) {
    return src;
  }
  const params = [`w=${width}`, `q=${quality || 90}`, "output=webp"];
  const encodedSrc = encodeURIComponent(src);
  return `https://wsrv.nl/?url=${encodedSrc}&${params.join("&")}`;
}
